import React from "react";
import { Check } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { motion } from "framer-motion";

const PatientValueProps = () => {
  const features = [
    {
      title: "Personalized Therapist Matching",
      description: "Find therapists based on language, culture, and your specific clinical needs.",
      icon: "🔍",
      benefits: [
        "Custom matching algorithm",
        "No generic directories"
      ]
    },
    {
      title: "Mental Health Assessment",
      description: "Take our quick quiz to help identify your needs and find the right support.",
      icon: "📝",
      benefits: [
        "Evidence-based screening",
        "Immediate results"
      ]
    },
    {
      title: "Trusted Network",
      description: "Access our carefully vetted network of culturally competent therapists.",
      icon: "🤝",
      benefits: [
        "Background-verified professionals",
        "Specialized training"
      ]
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">For Patients</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Start your journey to better mental health with tools designed to connect you with the right care.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="h-full border-none shadow-lg hover:shadow-xl transition-shadow bg-gradient-to-br from-white to-gray-50">
                <CardContent className="p-6 flex flex-col h-full">
                  <div className="text-4xl mb-4 flex items-center">
                    <span role="img" aria-label={feature.title}>{feature.icon}</span>
                    <h3 className="text-xl font-bold ml-2">{feature.title}</h3>
                  </div>
                  <p className="text-gray-600 flex-grow">{feature.description}</p>
                  <ul className="mt-4 space-y-2">
                    {feature.benefits.map((benefit, i) => (
                      <li key={i} className="flex items-start">
                        <Check className="h-5 w-5 text-green-500 mr-2 shrink-0 mt-0.5" />
                        <span className="text-sm">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PatientValueProps;
